import React from 'react';
import { Field } from 'react-final-form';
import { Input, Form, Label } from 'semantic-ui-react';

export const TextField = ({ name, label, ...restProps }) => (
    <Field name={name}>
        {({ input, meta }) => (
            <Form.Field>
                <label htmlFor={name}>{label}</label>
                <Input placeholder={label} {...input} {...restProps}/>
                {meta.error && meta.touched && <Label basic color='red' pointing>{meta.error}</Label>}
                {meta.submitError && <Label basic color='red' pointing>{meta.submitError}</Label>}
            </Form.Field>
        )}
    </Field>
);
